import { formatPathParams } from './formatPathParams';

/**
 * The data needed to make this request that is not provided by the axios
 * instance.
 */

export function makeRequester(axiosInstance) {
  return async (routeSchema, reqData, reqOptions) => {
    const response = await axiosInstance.request({
      ...reqOptions,
      method: routeSchema.method,
      url: formatPathParams(routeSchema.pathPattern, reqData.params),
      data: reqData.body,
      params: reqData.query
    });
    return response.data;
  };
}